import { render, staticRenderFns } from "./MostGoals.vue?vue&type=template&id=3b37b6f8&scoped=true&"
import script from "./MostGoals.vue?vue&type=script&lang=js&"
export * from "./MostGoals.vue?vue&type=script&lang=js&"
import style0 from "./MostGoals.vue?vue&type=style&index=0&id=3b37b6f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37b6f8",
  null
  
)

export default component.exports